import {
  AccountTransactionRequest,
  DocumentActionCategoryType,
  DocumentActionType,
  FileDocumentResponse,
} from '@finxone-platform/shared/sys-config-types';

export class GetTransactions {
  static readonly type = '[Account] GetTransactions';
  constructor(
    public accountId: string,
    public params: AccountTransactionRequest,
    public txsViewType?: string,
    public isLoaderShown = true,
  ) {}
}

export class SetLoadingStatus {
  static readonly type = '[Account] SetLoadingStatus';
  constructor(public isLoading: boolean) {}
}
export class ClearTransactionsCache {
  static readonly type = '[Account] ClearTransactionsCache';
}

export class GetExchangeTransactionById {
  static readonly type = '[Account] getExchangeTransactionById';
  constructor(public exchangeTransactionId: string, public transactionType: string) {}
}

export class ClearExchangeTransactionDetails {
  static readonly type = '[Account] ClearExchangeTransactionDetails';
}

export class GetTransactionById {
  static readonly type = '[Account] GetTransactionById';

  constructor(
    public currentTransactionNumber: string,
    public transactionId: string,
    public transactionType: string,
    public accountId: string,
  ) {}
}

export class GetScheduledTransactionDetailsById {
  static readonly type = '[Account] GetScheduledTransactionDetailsById';
  constructor(public scheduledTransactionId: string, public transactionType: string) {}
}

export class ClearTransactionDetails {
  static readonly type = '[Account] ClearTransactionDetails';
}

export class DeleteTransactionReceipt {
  static readonly type = '[Account] DeleteTransactionReceipt';
  constructor(public type: DocumentActionType, public transactionId: string, public documentId: string) {}
}

export class UploadTransactionReceipt {
  static readonly type = '[Account] UploadTransactionReceipt';
  constructor(public payload: FormData) {}
}

export class ReplaceTransactionReceipt {
  static readonly type = '[Account] ReplaceTransactionReceipt';
  constructor(public payload: FormData, public type: DocumentActionType, public transactionId: string) {}
}

export class UpdateTransactionReceiptDetails {
  static readonly type = '[Account] UpdateTransactionReceiptDetails';
  constructor(public fileDocumentResponse: FileDocumentResponse[]) {}
}

export class GetTransactionReceiptFileId {
  static readonly type = '[Account] GetTransactionReceiptFileId';
  constructor(
    public type: DocumentActionType,
    public transactionId: string,
    public documentSubCategory?: DocumentActionCategoryType,
  ) {}
}

export class ClearTransactionReceiptFileData {
  static readonly type = '[Account] ClearTransactionReceiptFileData';
}

export class GetTransactionReceiptFile {
  static readonly type = '[Account] DownloadFile';
  constructor(public type: DocumentActionType, public transactionId: string, public viewType: string) {}
}
